import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/common/components/Button/index.js